type RequiredAuthorizations = {
  [scope: string]: string[];
};

export class BinaryFileDataset {
  datatype: string | null = null;
  requiredAuthorizations: RequiredAuthorizations = {};
  from: string | null = null;
  to: string | null = null;
  comment: string | null = null;

  constructor(
    datatypeOrBinaryDataset?: string | Partial<BinaryFileDataset>,
    requiredAuthorizations?: RequiredAuthorizations,
    from?: string | null,
    to?: string | null,
    comment?: string,
  ) {
    if (datatypeOrBinaryDataset === undefined || datatypeOrBinaryDataset === null) {
      return;
    }

    if (typeof datatypeOrBinaryDataset === "string") {
      this.datatype = datatypeOrBinaryDataset;
      this.requiredAuthorizations = requiredAuthorizations || {};
      this.from = from || null;
      this.to = to || null;
      this.comment = comment || null;
    }
    else if (typeof datatypeOrBinaryDataset === "object") {
      this.datatype = datatypeOrBinaryDataset.datatype || null;
      this.requiredAuthorizations = datatypeOrBinaryDataset.requiredAuthorizations || {};
      this.from = datatypeOrBinaryDataset.from || null;
      this.to = datatypeOrBinaryDataset.to || null;
      this.comment = datatypeOrBinaryDataset.comment || null;
    }
  }

  get datasetKey(): string {
    const keyElements = {
      from: this.from,
      to: this.to,
      requiredAuthorizations: Object.keys(this.requiredAuthorizations || {})
        .sort()
        .reduce((acc: Record<string, string>, scope: string) => {
          const values = this.requiredAuthorizations[scope];
          acc[scope] = values?.[values.length - 1];
          return acc;
        }, {}),
    };

    return JSON.stringify(keyElements, Object.keys(keyElements).sort());
  }
}
